import { connect } from 'react-redux';
import { getPage } from './selectors';
import Page from './page';
import { openImpersonateDialog, impersonateDialogStarted } from '../actions/user';

const mapDispatchToProps = dispatch => {
    return {
        openDialog: () => {
            dispatch(openImpersonateDialog());
        },
        onFetchOrganizations: () => {
            dispatch(impersonateDialogStarted());
        },
    };
};

export default connect(state => getPage(state), mapDispatchToProps)(Page);
